import type { EntityType, StaticEntityType } from "@config";
import { cn } from "@lib/cn";
import { useIsPdf } from "@library/components";
import { useIsMobile } from "@library/shared";
import type { ReactNode } from "react";
import { useCarouselCtx } from "../../ctx";

interface IProps {
  set: StaticEntityType | EntityType;
  children: ReactNode;
}

export const CarouselItemWrapper = ({ set, children }: IProps) => {
  const { isFullScreen } = useCarouselCtx();
  const isPdf = useIsPdf();
  const isMobile = useIsMobile();
  // Only mobile fullscreen needs the wrapper to stretch — that's where the
  // swiper slides have real vertical room and the Set's verticalAlignment
  // setting was being squashed by tw-h-fit. Desktop fullscreen keeps its
  // prior tw-h-fit behavior so we don't regress its layout.
  const stretchToFullHeight = isFullScreen && isMobile && !isPdf;

  return (
    <div
      data-item-id={set.id}
      className={cn({
        "swiper-slide md:tw-px-20": !isPdf,
        "tw-px-4 md:tw-px-10": !isFullScreen && !isPdf,
        "tw-px-6 tw-py-8": isFullScreen && !isPdf,
        "tw-z-10 tw-w-full": isPdf,
        "tw-my-20": isFullScreen && isPdf,
        "tw-flex tw-justify-center": true,
        "tw-h-fit": !stretchToFullHeight,
        "tw-h-full tw-flex-col": stretchToFullHeight,
      })}
    >
      <div className="carousel-item-inner tw-relative tw-w-full tw-py-2">
        {children}
      </div>
    </div>
  );
};
